import { render, staticRenderFns } from "./MpmInput.vue?vue&type=template&id=61c8b756&scoped=true"
import script from "./MpmInput.vue?vue&type=script&lang=js"
export * from "./MpmInput.vue?vue&type=script&lang=js"
import style0 from "./MpmInput.vue?vue&type=style&index=0&id=61c8b756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b756",
  null
  
)

export default component.exports